import { Injectable } from '@angular/core';
import { ApolloQueryResult } from '@apollo/client/core';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { finalize } from 'rxjs/operators';

import {
  DataAccessService,
  GetDefaultPhasesDocument,
  GetDefaultPhasesQuery,
  GetPhaseByIdQuery,
  GetPhaseByIdDocument,
  FetchPhaseTipsCountDocument
} from '@tripointe/tripointe-cms/data-access';
import { TabWithDropdown } from '@tripointe/tripointe-cms/types';

@Injectable({
  providedIn: 'root'
})
export class CommonPhasesService {
  loading$ = new BehaviorSubject(false);
  phaseId$: BehaviorSubject<number> = new BehaviorSubject(null);
  phaseTipsListStatsCount$: BehaviorSubject<TabWithDropdown[]> = new BehaviorSubject([
    {
      name: 'phase tips',
      statsCount: null,
      archived: false
    }
  ]);
  phaseTipsListArchivedStatus$: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor(private dataAccess: DataAccessService) {}

  setLoading(isLoading: boolean): void {
    this.loading$.next(isLoading);
  }

  getPhaseById(phaseId: number): Observable<ApolloQueryResult<GetPhaseByIdQuery>> {
    this.setLoading(true);

    return this.dataAccess
      .get<GetPhaseByIdQuery>(GetPhaseByIdDocument, { phaseId })
      .pipe(finalize(() => this.setLoading(false)));
  }

  getPhaseTipsStats(phaseId: number, archivedStatus: boolean): void {
    this.dataAccess
      .get(FetchPhaseTipsCountDocument, { phaseId })
      .subscribe((res: ApolloQueryResult<any>) => {
        const stats = res.data['fetchPhaseTipsCount'];
        this.setPhaseTipsListStatsCount([
          {
            name: 'phase tips',
            archived: archivedStatus,
            statsCount: stats.statsCount
          }
        ]);
      });
  }

  setPhaseTipsListStatsCount(newStats: TabWithDropdown[]): void {
    this.phaseTipsListStatsCount$.next(newStats);
  }

  getPhaseTipsListStatsCount(): Observable<TabWithDropdown[]> {
    return this.phaseTipsListStatsCount$.asObservable();
  }

  setPhaseTipsListArchivedStatus(newStatus: boolean): void {
    this.phaseTipsListArchivedStatus$.next(newStatus);
  }

  getPhaseTipsListArchivedStatus(): Observable<boolean> {
    return this.phaseTipsListArchivedStatus$.asObservable();
  }

  getDefaultPhases(archived?: boolean): Observable<ApolloQueryResult<GetDefaultPhasesQuery>> {
    this.setLoading(true);

    return this.dataAccess
      .get<GetDefaultPhasesQuery>(GetDefaultPhasesDocument, { archived })
      .pipe(finalize(() => this.setLoading(false)));
  }
}
